import { render, staticRenderFns } from "./Contracts.vue?vue&type=template&id=a20634ea"
import script from "./Contracts.vue?vue&type=script&lang=ts"
export * from "./Contracts.vue?vue&type=script&lang=ts"
import style0 from "./Contracts.vue?vue&type=style&index=0&id=a20634ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports